<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <p class="progress-message mb-3">{{ data.message }}</p>

  <!-- Determinate Progress Bar with live percentage -->
  <div class="progress-wrapper" *ngIf="data.mode === 'determinate'; else indeterminateMode">
    <mat-progress-bar
      class="custom-progress-bar"
      mode="determinate"
      [value]="data.progress || 0">
    </mat-progress-bar>
    
    <div class="progress-details" style="display: flex; justify-content: space-between; margin-top: 0.5rem;">
      <span style="font-size: 0.85rem; color: #666;">Downloading document...</span>
      <span style="font-size: 0.85rem; font-weight: 600;">{{ data.progress || 0 }}%</span>
    </div>
  </div>

  <!-- Fallback Indeterminate Spinner -->
  <ng-template #indeterminateMode>
    <div style="display: flex; justify-content: center; padding: 1rem 0;">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end" (click)="close()">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>

